<div class="modal-body">
  <div class="card">
    <div class="modal-header modal-close">
      <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span
        aria-hidden="true">&times;</span></button>
    </div>
    <div class="card-header modal-card-header">
      <h4 class="form-section">
        <i class="ft-repeat"></i> {{ 'emailMessageDetails.title' | translate }}</h4>
    </div>
    <div class="card-body">
      <div class="px-3">

        <!-- EmailMessageId -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.emailMessageIdFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.EmailMessageId }}</div>
        </div>

        <!-- CreatedAt -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.createdAtFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.CreatedAt | date:'d-M-y HH:mm:ss' }}</div>
        </div>

        <!-- SentAt -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.sentAtFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.SentAt | date:'d-M-y HH:mm:ss' }}</div>
        </div>

        <!-- Status -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.statusFieldLabel' | translate }}</div>
          <div class="card-field-content"><i [ngClass]="currentObject.Status.IconClass"
                                             title="{{currentObject.Status.Description}}"></i></div>
        </div>

        <!-- RecipientEmailAddress -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.recipientEmailAddressFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.RecipientEmailAddress }}</div>
        </div>

        <!-- Subject -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.subjectFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.Subject }}</div>
        </div>

        <!-- Body -->
        <div class="card-field">
          <div class="card-field-label">{{ 'emailMessageDetails.bodyFieldLabel' | translate }}</div>
          <div class="card-field-content">{{ currentObject.Body }}</div>
        </div>

        <div class="form-actions">
          <button type="button" class="btn btn-secondary btn-raised mr-1 float-right" (click)="closeModal()">
            <i class="ft-x-square"></i> {{ 'buttons.closeText' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
